// Draggable-pin location picker for the owner-facing Velo Friendly form.
// Reuses AdminPlaceMapView with the owner form's input names. The element is
// only rendered once a location has been picked, so there is no default view to
// fall back to. Controls are stripped down to geolocate + zoom — owners pick a
// location through the form's own search box, not the map's.
export const UserVeloFriendlyMapHook: {
  el?: HTMLElement
  mounted: () => void
  destroyed: () => void
  unMountComponent?: (() => void) | undefined
  isDestroyed?: boolean
} = {
  mounted() {
    if (!this.el) {
      return
    }

    const rootElement = this.el
    const coordinatesStr = rootElement.dataset.coordinates

    let coordinates = null
    if (coordinatesStr && coordinatesStr !== 'null') {
      try {
        coordinates = JSON.parse(coordinatesStr)
      } catch (e) {
        console.error('Failed to parse coordinates:', e)
      }
    }

    void import('../../react/views/AdminPlaceMapView')
      .then(({ AdminPlaceMapView }) => {
        if (this.isDestroyed) {
          return
        }

        this.unMountComponent = AdminPlaceMapView({
          rootElement,
          liveView: this,
          placeData: { id: '', coordinates },
          inputOptions: {
            latInputName: 'owner_place[lat]',
            lngInputName: 'owner_place[lng]',
            hiddenInputId: 'owner_place_location_coordinates',
          },
          minimalControls: true,
        })
      })
      .catch((error) => {
        console.error('[UserVeloFriendlyMapHook] Failed to load map view:', error)
      })
  },
  destroyed() {
    this.isDestroyed = true
    this.unMountComponent?.()
  },
}
